import {
    IonButton,
    IonCard,
    IonCol,
    IonItem,
    IonLabel,
    IonModal,
    IonRow,
    IonText,
} from "@ionic/react";
import moment from "moment";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import "./DobModal.css";

interface DobModalProps {
    openDobModal: boolean;

    onDismiss(): void;

    dob(date: string): void;

    /** i18n key for the heading. Defaults to the heart-rate-zones wording. */
    titleKey?: string;
    /** i18n keys for the explanatory paragraphs. Defaults to the heart-rate-zones wording. */
    descriptionKeys?: string[];
}

export const DobModal: FC<DobModalProps> = ({
    openDobModal,
    onDismiss,
    dob,
    titleKey = "stats.stats.HeartRate.dateOfBirthPopUp.title",
    descriptionKeys = [
        "stats.stats.HeartRate.dateOfBirthPopUp.overviewDescription",
        "stats.stats.HeartRate.dateOfBirthPopUp.inputDescription",
    ],
}) => {
    const { t } = useTranslation();
    const [date, setDate] = useState<string>("");

    return (
        <IonModal
            isOpen={openDobModal}
            onDidDismiss={() => onDismiss()}
            initialBreakpoint={1}
            showBackdrop
        >
            <IonCard className="ion-card-transparent">
                <IonItem className="teams-segments-container">
                    <IonText>{t(titleKey)}</IonText>
                </IonItem>

                <IonItem className="teams-segments-container">
                    <IonRow>
                        {descriptionKeys.map((key) => (
                            <IonText key={key}>{t(key)}</IonText>
                        ))}
                    </IonRow>
                </IonItem>

                <IonItem className="margin" lines="none">
                    <IonLabel>{t("stats.stats.Filters.date")}</IonLabel>
                    <input
                        data-testid="datePicker"
                        className="date-input large"
                        type="date"
                        value={moment(date).format("YYYY-MM-DD")}
                        onChange={(e) =>
                            setDate(moment(e.currentTarget.value).toISOString())
                        }
                    />
                </IonItem>
                <IonItem className="teams-segments-container">
                    <IonCol>
                        <IonButton
                            data-testid="cancelDobDate"
                            expand="block"
                            onClick={() => onDismiss()}
                        >
                            {t("general.cancel")}
                        </IonButton>
                    </IonCol>

                    <IonCol>
                        <IonButton
                            data-testid="saveDobDate"
                            expand="block"
                            onClick={() => dob(date)}
                        >
                            {t("general.save")}
                        </IonButton>
                    </IonCol>
                </IonItem>
            </IonCard>
        </IonModal>
    );
};
